/** Colores por empresa (mismo criterio que RRHH2 > Empleados). */
export const coloresEmpresas = {
  1: "#1e3a8a", // Hipergas
  2: "#1e3a8a", // Hipergas / Italgas
  4: "#4c1d95", // Natural Gas
  5: "#881337", // Metalgar
  99: "#92400e", // Netizar
};

export const COLOR_EMPRESA_DEFAULT = "#2471A3";

export const colorDeEmpresa = (idEmpresa) => {
  if (idEmpresa == null || idEmpresa === "") return COLOR_EMPRESA_DEFAULT;
  return coloresEmpresas[Number(idEmpresa)] || COLOR_EMPRESA_DEFAULT;
};
